import {useState} from 'react';

export default class ContribuicaoModel {

  public codContribuinte: any;
  public setCodContribuinte: any;
  public cdStatusAnalise: any;
  public setCdStatusAnalise: any;
  public dsContribuicao: any;
  public setDsContribuicao: any;
  public dsJustificativa: any;
  public setDsJustificativa: any;
  public dsJustificativaAnalise: any;
  public setDsJustificativaAnalise: any;
  public dsContribuicaoSigilosa: any;
  public setDsContribuicaoSigilosa: any;
  public protocolo: any;
  public setProtocolo: any;

  public contribuicaoList: any;
  public setContribuicaoList: any;

  public contribuicao: any;
  public setContribuicao: any;

  constructor() {
    [this.codContribuinte, this.setCodContribuinte] = useState('');
    [this.cdStatusAnalise, this.setCdStatusAnalise] = useState('');
    [this.dsContribuicao, this.setDsContribuicao] = useState('');
    [this.dsJustificativa, this.setDsJustificativa] = useState('');
    [this.dsJustificativaAnalise, this.setDsJustificativaAnalise] = useState('');
    [this.dsContribuicaoSigilosa, this.setDsContribuicaoSigilosa] = useState('');
    [this.protocolo, this.setProtocolo] = useState('');

    [this.contribuicaoList, this.setContribuicaoList] = useState([]);
    [this.contribuicao, this.setContribuicao] = useState('');
  }
  
  public sync(obj: any) {
    this.setCodContribuinte(obj.codContribuinte);
    this.setDsContribuicao(obj.dsContribuicao);
    this.setDsContribuicaoSigilosa(obj.dsContribuicaoSigilosa);
    this.setDsJustificativa(obj.dsJustificativa);
    this.setProtocolo(obj.protocolo);


    this.setContribuicao(obj.contribuicao);

    this.extrairContribuicao(obj);
  }

  private extrairContribuicao(entity: any) {
    if (!entity.contribuicao || entity.contribuicao.length === 0) {
      return;
    }
    const list = [];
    for (const pm of entity.contribuicao) {
      if (!!pm.contribuicao && pm.contribuicao.length > 0) {
        list.push(...pm.contribuicao);
      }
    }

    this.setContribuicaoList(list);
  }
}
